<template>
  <div>
    <button
      class="btn btn-primary btn-float-legend shadow"
      :class="{ 'show-btn-legend ': legend }"
      @click="toggleLegend()"
    >
      <font-awesome-icon :icon="['fas', 'question']" class="fa-1x" />
    </button>
    <div class="card card-legend shadow" :class="{ 'show-legend ': legend }">
      <div class="card-header text-primary font-weight-bold">Groups</div>
      <div class="card-body py-1 px-2">
        <ul class="list-group list-group-flush">
          <li class="list-group-item" v-for="group in groups" :key="group.name">
            <strong>{{ group.name }}</strong> <br />
            ({{ group.ddi }}) <br />
            {{ formatMembers(group.members)  }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Legend",
  props: ['groups'],
  data: () => ({
    legend: false,
  }),
  methods: {
    toggleLegend() {
      this.legend = !this.legend;
    },
    formatMembers(members) {
      return members.join(', ');
    }
  },
};
</script>
<style scoped>
.btn-float-legend {
  position: absolute;
  right: 0px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  border-right: none;
  z-index: 1;
}

.show-btn-legend {
  right: 300px !important;
}

.show-legend {
  display: block !important;
}

.card-legend {
  position: absolute;
  right: 0;
  width: 300px;
  height: auto;
  display: none;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  z-index: 1;
  top: 80px;
}
</style>